import React from 'react'

const LeftArrow = ({onClick = null}) => {
    return (
        <svg onClick={onClick} width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.7" cx="21.1008" cy="21.1008" r="21.1008" fill="white"/>
            <path d="M11.2045 20.7341C10.814 21.1246 10.814 21.7577 11.2045 22.1483L17.5685 28.5122C17.959 28.9028 18.5922 28.9028 18.9827 28.5122C19.3732 28.1217 19.3732 27.4885 18.9827 27.098L13.3258 21.4412L18.9827 15.7843C19.3732 15.3938 19.3732 14.7606 18.9827 14.3701C18.5922 13.9796 17.959 13.9796 17.5685 14.3701L11.2045 20.7341ZM29.9494 20.4412L11.9116 20.4412V22.4412L29.9494 22.4412V20.4412Z" fill="#606060"/>
        </svg>
    )
}

export default LeftArrow